import { connect } from 'react-redux';
import { TApplicationState } from '../../types/redux';
import { Header, IHeaderProps } from '../../components/Header';
import { getFromDevelopersPropsCount, getNewbuildingDisplayName } from '../../selectors/newbuilding';

type THeaderStateProps = Pick<IHeaderProps, 'name' | 'fromDevelopersPropsCount'>;

export function mapStateToProps(state: TApplicationState): THeaderStateProps {
  return {
    fromDevelopersPropsCount: getFromDevelopersPropsCount(state),
    name: getNewbuildingDisplayName(state),
  };
}

export const HeaderContainer = connect(mapStateToProps)(Header);
